// @ts-check

import { AddToTranscriptStatus } from '../add-to-transcript-status';
import { Err, Ok } from '@crvouga/result';
import connectorService from '../../../services/connector.service.js';

/**
 * @typedef {{
 *  type: 'ulc-api-hub'
 * }} Config
 */

/**
 * @type {(config: Config) => import('./interface').AddToTranscriptAPI}
 */
export const AddToTranscriptAPI = () => {
  return {
    async post({ asurite, enrollmentId }) {
      try {
        const json = await connectorService.postAddToTranscript({ asurite, enrollmentId });
        return Ok(json);
      } catch (error) {
        if (error instanceof Error) {
          return Err(error);
        }
        return Err(new Error(String(error)));
      }
    },

    async get({ asurite, enrollmentId }) {
      try {
        const json = await connectorService.getAddToTranscriptStatus({ asurite, enrollmentId });
        if (typeof json === 'object' && json !== null && 'status' in json && typeof json.status === 'string') {
          const status = AddToTranscriptStatus.fromUnknown(json.status);
          return Ok({ status });
        }
        return Err(new Error('Failed to parse response from server'));
      } catch (error) {
        if (error instanceof Error) {
          return Err(error);
        }
        return Err(new Error(String(error)));
      }
    }
  };
};
